/* @flow */

import { type AxiosPromise } from 'axios';
import getInputPorId from '../../utils/get-input-por-id';
import xhr from '../../utils/xhr';

import { type Packages } from '../../empresa/types';

const preencherFormularioPackages = (urlLojas: Packages) => {
    getInputPorId('ios-empresas-packages').value = urlLojas.ios;
    getInputPorId('android-empresas-packages').value = urlLojas.android;
};

const getDadosFormularioPackages = (): Packages => ({
    ios: getInputPorId('ios-empresas-packages').value,
    android: getInputPorId('android-empresas-packages').value,
});

const buscarPackages = (empresasId: number): AxiosPromise<Packages> => xhr.get(`/empresas/${empresasId}/packages`);

const cadastrarPackages = (empresasId: number, urlLojas: Packages): AxiosPromise<*> => (
    xhr.post(`/empresas/${empresasId}/packages`, urlLojas)
);

export {
    preencherFormularioPackages,
    getDadosFormularioPackages,
    buscarPackages,
    cadastrarPackages,
};
